import * as IconSelector from '../icons';

export const tipoEnvase = [
    {
        value: 'Botella',
        label: 'Botella',
        description: 'Auxiliar',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Bag in Box',
        label: 'Bag in Box',
        description: 'Bag in Box',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    }
];
